import { SHORTCUTS } from '@/lib/shortcuts';

interface Props {
  open: boolean;
  onClose: () => void;
}

export default function ShortcutsHelp({ open, onClose }: Props) {
  if (!open) return null;

  const groups = Array.from(new Set(SHORTCUTS.map((item) => item.group)));

  return (
    <div
      className="ln-modal-backdrop"
      role="dialog"
      aria-modal="true"
      aria-label="Keyboard shortcuts"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <div className="ln-shortcuts">
        {groups.map((group) => (
          <div key={group}>
            <div className="ln-shortcuts-group">{group}</div>
            {SHORTCUTS.filter((item) => item.group === group).map((item) => (
              <div key={`${item.group}-${item.keys}`} className="ln-shortcuts-row">
                <span className="ln-kbd">{item.keys}</span>
                <span>{item.label}</span>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
